import type { ComponentContentSchema } from '@vibesites/runtime';
import { RichTextContent } from '@vibesites/runtime/react';
import { CommunitiesMapCanvas } from './CommunitiesMapCanvas';
import { useCommunitiesBrowse } from './communitiesBrowseStore';

export function CommunitiesMap() {
  const browse = useCommunitiesBrowse();
  const hiddenOnMobile = browse.mobileView === 'list';

  return (
    <section
      id="communities-map"
      className={`relative w-full bg-[rgb(var(--ala-surface))] ${hiddenOnMobile ? 'max-lg:hidden' : ''}`}
    >
      <div className="sr-only">
        <RichTextContent path="communitiesmap.heading" label="Map heading" as="h2" />
      </div>

      <CommunitiesMapCanvas
        heightClassName="h-[calc(100svh-4.75rem)] lg:h-[min(70vh,620px)]"
        errorLabel={
          <RichTextContent
            path="communitiesmap.error_label"
            label="Map error"
            as="p"
            className="font-body text-sm text-[rgb(var(--ala-text-muted))]"
          />
        }
        emptyLabel={
          <RichTextContent
            path="communitiesmap.empty_label"
            label="Map empty"
            as="p"
            className="font-body text-sm text-[rgb(var(--ala-text-muted))]"
          />
        }
      />
    </section>
  );
}

export const contentSchema: ComponentContentSchema = {
  slot: 'CommunitiesMap',
  displayName: 'Communities Map',
  tokens: {
    'communitiesmap.heading': {
      label: 'Map heading',
      type: 'richtext',
      defaultValue: '<p>Explore our communities</p>',
    },
    'communitiesmap.error_label': {
      label: 'Map error',
      type: 'richtext',
      defaultValue: '<p>Map unavailable. Browse communities below.</p>',
    },
    'communitiesmap.empty_label': {
      label: 'Map empty',
      type: 'richtext',
      defaultValue: '<p>No mapped communities are available yet.</p>',
    },
  },
};

(CommunitiesMap as unknown as { contentSchema: ComponentContentSchema }).contentSchema =
  contentSchema;

export default CommunitiesMap;
